module.exports = __webpack_public_path__ + "media/images/players/BURMESTER_DEAN-d6a3a9967b4d81e003fa31e42b1cc85a.png";